export { default } from './KitDividerWithText';
